import { CompanyTypeEnum } from "@simbelapp/order-sdk";
import { ColorsTypeEnum } from "./colores.enums";

export enum CompanyIdentificationModeEnum {
  EMAIL = "email",
  EMPLOYEE_NUMBER = "employee_number",
}

export enum CompanyAuthStrategy {
  LOGIN_PASSWORD = "email_password",
  SSO_SAML = "sso_saml",
}

export enum CompanyLanguage {
  FR = "fr",
  EN = "en",
}

/** Tabs of the company edit modal on /admin/log-as. Only GENERAL exists while creating a company. */
export enum CompanyModalTabEnum {
  GENERAL = "general",
  SSO = "sso",
  DASHBOARD = "dashboard",
  THREE_SIXTY = "three_sixty",
  DOCEBO = "docebo",
  API = "api",
  SFTP = "sftp",
}

/**
 * What the « API » tab shows about a company's Simbel API credentials. ERROR is a read that
 * failed and must never pass for NOT_CONFIGURED: credentials may well exist, and generating would
 * replace them.
 */
export enum ApiCredentialsStateEnum {
  LOADING = "loading",
  NOT_CONFIGURED = "not_configured",
  CONFIGURED = "configured",
  ERROR = "error",
}

export const COMPANY_TYPE_LABELS: Record<CompanyTypeEnum, string> = {
  [CompanyTypeEnum.Live]: "Live",
  [CompanyTypeEnum.Demo]: "Démo",
  [CompanyTypeEnum.Test]: "Test",
  [CompanyTypeEnum.Churn]: "Churn",
};

export const COMPANY_TYPE_TAG_TYPES: Record<CompanyTypeEnum, ColorsTypeEnum> = {
  [CompanyTypeEnum.Live]: ColorsTypeEnum.LIGHT_GREEN,
  [CompanyTypeEnum.Demo]: ColorsTypeEnum.LIGHT_BLUE,
  [CompanyTypeEnum.Test]: ColorsTypeEnum.LIGHT_ORANGE,
  [CompanyTypeEnum.Churn]: ColorsTypeEnum.LIGHT_RED,
};
